/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Setup_Display_NameInputs */

const en_setup_display_name = /** @type {(inputs: Setup_Display_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Your name`)
};

const de_setup_display_name = /** @type {(inputs: Setup_Display_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dein Name`)
};

/**
* | output |
* | --- |
* | "Your name" |
*
* @param {Setup_Display_NameInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const setup_display_name = /** @type {((inputs?: Setup_Display_NameInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Setup_Display_NameInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_setup_display_name(inputs)
	return en_setup_display_name(inputs)
});